import axios from "axios";
import { SETTINGS } from "../../Settings";
import store from "../../store/Store";
import { removeCurrentUser } from "../../store/AuthSlice";
import { jwtDecode } from "jwt-decode";

export const AuthRepository = {
  fetchToken: (username, password, captchaToken) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}auth/authenticate`,
      method: "POST",
      data: {
        username: username,
        password: password,
        captchaToken: captchaToken,
      },
      withCredentials: true,
    });
  },

  logout: () => {
    store.dispatch(removeCurrentUser());
  },

  hasAnyRole: (roles) => {
    if (window?.localStorage?.getItem("accessToken")) {
      var currentUser = jwtDecode(window?.localStorage?.getItem("accessToken"));
      if (currentUser?.roles?.filter((r) => roles.includes(r)).length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
};
